<template>

<custom-input title="Verstorbener">
    <input name="deceased_name" class="form-control" required="required" v-model="deceaseds.model.name" list="deceased_list">
    <datalist id="deceased_list">
        <option v-for="deceased in $store.getters.models('deceaseds')">{{ deceased.id }}: {{ deceased.lastname }}, {{ deceased.firstname }}</option>
    </datalist>
</custom-input>

</template>

<script>
import CustomInput from 'components/custom-input.vue'

export default {
  components: {
    CustomInput
  }
}
</script>



// WEBPACK FOOTER //
// customer-deceased.vue?7a68bc07